import React from 'react';
import { clsx } from 'clsx';
import OutrisFaviconDark from '../assets/outris-square-dark.svg';
import OutrisFaviconLight from '../assets/outris-square-light.svg';
import { useSidebarCollapse } from '../contexts/SidebarContext';
import { EdgeCollapseTab } from './workbench/EdgeCollapseTab';
import { SidebarNavContent } from './SidebarNavContent';

export const Sidebar: React.FC = () => {
    const { isCollapsed, toggleSidebar } = useSidebarCollapse();

    return (
        <div
            className={clsx(
                'relative z-20 shrink-0 hidden lg:flex flex-col min-h-0 self-stretch transition-[width] duration-200 ease-in-out',
                isCollapsed ? 'w-16' : 'w-56',
            )}
        >
            <aside className="flex flex-col flex-1 min-h-0 overflow-hidden border-r border-border bg-card">
                <div className={clsx('flex-1 min-h-0 overflow-y-auto overflow-x-hidden styled-scrollbar page-scrollbar', isCollapsed ? 'px-2 py-3' : 'p-4')}>
                    <SidebarNavContent isCollapsed={isCollapsed} />
                </div>

                <div className={clsx(
                    'mt-auto shrink-0 border-t border-primary/30 flex items-center justify-center',
                    isCollapsed ? 'px-2 py-3' : 'p-4',
                )}>
                    <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
                        <img src={OutrisFaviconLight} alt="Outris" className={clsx('block dark:hidden', isCollapsed ? 'h-7 w-7' : 'h-6 w-6')} />
                        <img src={OutrisFaviconDark} alt="Outris" className={clsx('hidden dark:block', isCollapsed ? 'h-7 w-7' : 'h-6 w-6')} />
                        {!isCollapsed && (
                            <span>Powered by <span className="font-medium text-foreground/80">Outris</span></span>
                        )}
                    </div>
                </div>
            </aside>
            <EdgeCollapseTab
                side="right"
                direction={isCollapsed ? 'expand' : 'collapse'}
                onClick={toggleSidebar}
                label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            />
        </div>
    );
};
